import * as yup from "yup";

export const fundFamilyDateSchema = yup
  .object()
  .shape(
    {
      commitment_start_date: yup.date().nullable().optional(),
      commitment_end_date: yup
        .date()
        .required()
        .when(["commitment_start_date"], ([commitment_start_date], schema) =>
          commitment_start_date &&
          !isNaN((commitment_start_date as Date).getTime())
            ? schema.min(commitment_start_date)
            : schema,
        ),
      fund_start_date: yup.date().required(),
      fund_end_date: yup
        .date()
        .required()
        .when(["fund_start_date"], ([fund_start_date], schema) =>
          fund_start_date && !isNaN((fund_start_date as Date).getTime())
            ? schema.min(fund_start_date)
            : schema,
        ),
      investment_start_date: yup.date().required(),
      investment_end_date: yup
        .date()
        .required()
        .when(["investment_start_date"], ([investment_start_date], schema) =>
          investment_start_date &&
          !isNaN((investment_start_date as Date).getTime())
            ? schema.min(investment_start_date)
            : schema,
        ),
    },
    [
      ["fund_start_date", "fund_end_date"],
      ["commitment_start_date", "commitment_end_date"],
      ["investment_start_date", "investment_end_date"],
    ],
  )
  .required();
